// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal__1-by7","modal__content":"modal__content__EGCph","modal__buttons":"modal__buttons__3XNNQ"};